const reportReviewEN = {
	title: "Report Review",
	subtitle: "Why are you reporting this review?",
	reason: {
		spam: "Spam or fake",
		inappropriate: "Inappropriate or offensive",
		harassment: "Harassment or bullying",
		incorrect: "Incorrect information",
		other: "Other",
	},
	placeholder: "Add more details (optional)",
	actions: {
		cancel: "Cancel",
		submit: "Submit Report",
		success: "Report submitted",
	},
};

export default reportReviewEN;